import data from "../../../../../src/Radio/Radio.docs.json";
import * as React from 'react';
export default {
  data,
  React
};